export default "__VITE_ASSET__8$vGP4y7__"